// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2Qo0s","row":"Node_row__1WUpq","label":"Node_label__2zpEg","footer":"Node_footer__1Fvf6"};